export const COVER_DATA_SCANNING_MAPPING = {
	'background-image.png':
		'https://imagedelivery.net/28-eDrK8lEif6_ED0iMQeg/56197c7d-3769-4364-45cb-acd75a234c00/backgrounds',
	'banner-image.png':
		'https://imagedelivery.net/28-eDrK8lEif6_ED0iMQeg/4051fa30-e1e2-4868-9d40-142c98857000/public',
};
